import React, { useEffect } from "react";
import { AtButton, AtCheckbox, AtForm, AtInput, AtInputNumber, AtRadio, AtSwitch, AtTextarea } from "taro-ui";
import SelectorPicker from "widgetsTaro/AtPickerWidget/component/SelectorPicker";
import DateTimerPicker from "../../AtPickerWidget/component/DateTimerPicker";
import styled from "styled-components";
import TImagePickerWidget from "../../AtImagePickerWidget/component";
import _ from "lodash";
import moment from "moment";

const form_col:any = {
  6: '25%',
  8: '33.33%',
  12: '50%',
  24: '100%',
};
const AtFormBtnWrapper = styled.div`
  display: flex;
  padding: 0 10px;
  gap: 10px;
  .at-button{
    flex: 1;
  }
  .primary{
    background-color: #006cf2;
    color: #fff;
  }
  .text{
    border: none;
  }
`;
const AtFormWrapper = styled(AtForm)<{
  labelPosition: string;
  labelTextColor: string;
  labelTextSize: string;
  labelStyle: string;
  inputTextColor: string;
  inputTextSize: string;
  inputStyle: string;
  backgroundColor: string;
  labelAlignment: string;
  colSpans: number;
  labelWidth: number;
  lineHeight: number;
}>`
  padding: 10px 10px 0 10px;
  height: calc(100% - 40px);
  overflow-y: auto;
  background-color: ${({backgroundColor})=> backgroundColor}!important;
  form{
    display: flex;
    flex-wrap: wrap;
  }
  .form_item{
    display: ${({labelPosition})=> labelPosition=='Left'?'flex':'block'};
    border-bottom: 1px solid #f4f4f4;
    margin-bottom: ${({lineHeight})=> lineHeight}px;
    padding-bottom: 1px;
    width: ${({colSpans})=> form_col[colSpans]};
    box-sizing: border-box;
  }
  .form_item_left{
    width: ${({labelWidth})=> labelWidth}px;
    text-align: ${({labelAlignment})=> labelAlignment};
    padding-right: 4px;
  }
  .form_required{
    color: #f00;
  }
  .form_item_right{
    width: 100%;
    flex: 1
  }

  .at-input:after,
  .at-list:after,
  .at-checkbox:before,
  .at-checkbox:after,
  .at-radio:before,
  .at-radio:after,
  .at-radio__option + .at-radio__option .at-radio__option-wrap:after,
  .at-checkbox__option + .at-checkbox__option .at-checkbox__option-wrap:after,
  .at-switch__title,
  &.at-form:after{
    display: none;
  }
  .at-textarea{
    border: none;
  }
  .at-switch__container{
    flex-direction: row;
  }
  .at-checkbox__icon-cnt{
    border-radius: 2px
  }
  .form_item_label{
    color: ${({labelTextColor})=> labelTextColor };
    font-size: ${({labelTextSize})=> labelTextSize };
    font-weight: ${({labelStyle})=> labelStyle&&labelStyle.indexOf('BOLD')>=0?'bold':'normal' };
    font-style: ${({labelStyle})=> labelStyle&&labelStyle.indexOf('ITALIC')>=0?'italic':'normal' };
    line-height: 30px;
  }

  .item-extra__info,
  .at-checkbox__title,
  .at-radio__title{
    color: ${({inputTextColor})=> inputTextColor }!important;
    font-size: ${({inputTextSize})=> inputTextSize }!important;
    font-weight: ${({inputStyle})=> inputStyle&&inputStyle.indexOf('BOLD')>=0?'bold':'normal' };
    font-style: ${({inputStyle})=> inputStyle&&inputStyle.indexOf('ITALIC')>=0?'italic':'normal' };
  }
`;
function AtDynamicFormsWidget (props:any){
  const {
    labelPosition,
    labelWidth,
    lineHeight,
    labelTextColor,
    labelTextSize,
    labelStyle,
    inputTextColor,
    inputTextSize,
    inputStyle,
    backgroundColor,
    labelAlignment,
    colSpans,
    isDisabled,
    isReadonly,
    isValid,
    buttons,
    currentData,
    updateWidgetMeta,
    onExecuteAction
  } = props;
  const onReset = ()=>{
    let newCurrentData = currentData.map((i:any)=>{
      let reset_value:any = '';
      let v_type = typeof i.value;
      if(v_type == 'number' ){
        reset_value = 0;
      }else if(Array.isArray(i.value)){
        reset_value = [];
      }
      return {
        ...i,
        value: reset_value
      }
    })
    updateWidgetMeta(newCurrentData, 'currentData');
  }
  const onChange = (data:any)=>{
    let newCurrentData = currentData.map((i:any)=>{
      return {
        ...i,
        value: data.key === i.id?data.value:i.value
      }
    })
    updateWidgetMeta(newCurrentData, 'currentData');
  }
  useEffect(()=>{
    let form_valid = true;
    _.each(currentData, (i:any)=>{
      if(i.required && (i.value==undefined||i.value==''||i.value == null)){
        form_valid = false;
      }
    })
    updateWidgetMeta(form_valid, 'isValid');
  }, [currentData]);
  return (
    <>
      <AtFormWrapper
        labelPosition={labelPosition}
        labelWidth={labelWidth*10}
        lineHeight={lineHeight}
        labelTextColor={labelTextColor}
        labelTextSize={labelTextSize}
        labelStyle={labelStyle}
        inputTextColor={inputTextColor}
        inputTextSize={inputTextSize}
        inputStyle={inputStyle}
        backgroundColor={backgroundColor}
        labelAlignment={labelAlignment}
        colSpans={colSpans}
      >
        {currentData.map((i:any)=>{
          return (
            <div className="form_item" key={i.id}>
              <div className="form_item_left">
                {
                  i.required&&<span className="form_required">*</span>
                }
                <span className="form_item_label">{i.name}</span>
              </div>
              <div className="form_item_right">
                {
                  isReadonly?<FormItemText itemData={i} />:<FormItem
                    itemData={i}
                    isDisabled={isDisabled}
                    isReadonly={isReadonly}
                    onChange={onChange}
                  />
                }

              </div>
            </div>
          )
        })}
      </AtFormWrapper>
      <AtFormBtnWrapper>
        {
          Object.values(buttons).sort((a:any,b:any)=> (a.index-b.index)).map((i:any)=>{
            return <AtButton disabled={i.disabledWhenInvalid&&!isValid} className={i.buttonVariant} key={i.id} onClick={()=>{
              i.onClick&&onExecuteAction(i.onClick);
              i.resetFormOnClick&&onReset();
            }}>{i.label}</AtButton>
          })
        }
      </AtFormBtnWrapper>
    </>
  )
}
function FormItemText(props:any){
  const {itemData} = props;
  if(['switch', 'boolean'].includes(itemData.type)){
    return itemData.value?'true':'false';
  }else if(['date'].includes(itemData.type)){
    return itemData.value?moment(itemData.value).format('YYYY-MM-DD'):null;
  }else if(['select', 'dict', 'enum'].includes(itemData.type)){
    let item = itemData.formValues.filter((i:any)=>{
      return i.id == itemData.value;
    })
    return item?.[0]?.name;
  }else if(['radio', 'bool'].includes(itemData.type)){
    let item = itemData.formValues.filter((i:any)=>{
      return i.id == itemData.value;
    })
    return item?.[0]?.name;
  }else if(['checkbox'].includes(itemData.type)){
    let names:any = [];
    _.each(itemData.formValues, (item:any)=>{
      if(itemData.value.includes(item.id)){
        names.push(item.name);
      }
    })
    return names.join(',');
  }else if(['upload', 'image'].includes(itemData.type)){
    return <TImagePickerWidget
      isDisabled={true}
      readonly={true}
      value={itemData.value}
      fileCount={1}
      previewSize={100}
      upIconColor='#ccc'
      upBorderColor='#ccc'
      borderRadius='2px'
      borderBottomWidth={1} />
  }else{
    return itemData.value;
  }

}
function FormItem(props:any){
  const {itemData, isDisabled, onChange} = props;
  const valueChange = (value:any)=>{
    onChange({
      value,
      key: itemData.id
    })
  }
  if(['switch', 'boolean'].includes(itemData.type)){
    return <AtSwitch disabled={isDisabled} checked={itemData.value} onChange={valueChange} />
  }else if(['date'].includes(itemData.type)){
    return <DateTimerPicker isDisabled={isDisabled} placeholder="请选择" value={itemData.value} dateFields='day' onDateChange={valueChange} />
  }else if(['select', 'dict', 'enum'].includes(itemData.type)){
    let opts = itemData.formValues.map((i:any)=>{
      return {
        label: i.name,
        value: i.id
      }
    })
    return <SelectorPicker isDisabled={isDisabled} placeholder="请选择" value={itemData.value} selectorOptions={opts} onDateChange={valueChange} />
  }else if(['inputNumber', 'integer', 'long'].includes(itemData.type)){
    return <AtInputNumber disabled={isDisabled} type="number" step={1} value={itemData.value} onChange={valueChange} />
  }else if(['radio', 'bool'].includes(itemData.type)){
    let opts = itemData.formValues.map((i:any)=>{
      return {
        label: i.name,
        value: i.id,
        disabled: !!isDisabled
      }
    })
    return <AtRadio options={opts} value={itemData.value} onClick={valueChange} />
  }else if(['textarea', 'textArea'].includes(itemData.type)){
    return <AtTextarea
      disabled={isDisabled}
      count={false}
      value={itemData.value}
      onChange={valueChange}
      maxLength={200}
      placeholder='请输入'
    />
  }else if(['checkbox'].includes(itemData.type)){
    let opts = itemData.formValues.map((i:any)=>{
      return {
        label: i.name,
        value: i.id,
        disabled: !!isDisabled
      }
    })
    return <AtCheckbox
      options={opts}
      selectedList={itemData.value}
      onChange={valueChange}
    />
  }else if(['upload', 'image'].includes(itemData.type)){
    return <TImagePickerWidget
      isDisabled={isDisabled}
      value={itemData.value}
      fileCount={10}
      previewSize={100}
      upIconColor='#ccc'
      upBorderColor='#ccc'
      borderRadius='2px'
      borderBottomWidth={1}
      updateMetaValue={valueChange} />
  }else{
    return <AtInput disabled={isDisabled} placeholder="请输入" name={itemData.id} type='text' value={itemData.value} onChange={valueChange} />
  }
}


export default AtDynamicFormsWidget;
